'use client';

import { useIntl } from 'react-intl';

import { BrandHandMarkTwoLinesVariant2 } from '../../../../../design-system/components/illustration/BrandHandMarkTwoLinesVariant2';

import style from './Title.module.css';

export function MarketingTitle() {
    const { formatMessage } = useIntl();

    return (
        <div className={style.container}>
            <h2 className={style.title}>
                {formatMessage(
                    { id: 'page.home.MarketingSection.title' },
                    {
                        strong: (chunks) => {
                            return (
                                <strong
                                    key={`title-emphasis-${String(chunks)}`}
                                    className={style.titleEmphasis}
                                >
                                    {chunks}
                                    <BrandHandMarkTwoLinesVariant2 className={style.handMark} />
                                </strong>
                            );
                        },
                    },
                )}
            </h2>
            <p className={style.subtitle}>
                {formatMessage({ id: 'page.home.MarketingSection.subtitle' })}
            </p>
        </div>
    );
}
